import { FlexBox, IconButton, Text, Tooltip } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { ampli } from 'lib-shared-tracking';
import { PureComponent } from 'react';

import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';

type PropsT = {
  isMenuOpen: boolean;
  toggleSidebar: () => void;
};

export class SidebarToggleTrigger extends PureComponent<PropsT> {
  @boundMethod
  public toggleSidebar(): void {
    if (!this.props.isMenuOpen) {
      ampli.conversationSidebarOpened();
    } else {
      ampli.conversationSidebarClosed();
    }

    this.props.toggleSidebar();
  }
  render() {
    const { isMenuOpen } = this.props;

    const tooltipContent = (
      <CommandKeybindingsTooltipContent commandName="app:toggleRightSidebar">
        {isMenuOpen ? 'Close' : 'Show'}
      </CommandKeybindingsTooltipContent>
    );

    return (
      <FlexBox alignItems="center" justifyContent="space-between" padding="300">
        {isMenuOpen && (
          <Text.Paragraph variant="3" subdued>
            Customer Info
          </Text.Paragraph>
        )}

        <Tooltip content={tooltipContent}>
          <IconButton
            variant="tertiary"
            onClick={this.toggleSidebar}
            icon={isMenuOpen ? 'angle-double-right' : 'angle-double-left'}
          />
        </Tooltip>
      </FlexBox>
    );
  }
}
